export default {
    rechercheLists: [],
    addresslist: [],
    ambassadorslist: [],
    evaluations: [],
    meilisearchContent: [],
    searchParamMeiliSearch: '',
    totalCountMeiliSearch: null,
    completeCustomFilter: null,
    saveListStatus: false,
    saveListMaxLimit: null,
    poolData: [],
    lastAddedList: [],
    lastListAddedStatus: false,
    modalLastAddressesStatus: false,
    saveQueryAllFilters: [],
    savedListsNames: [],
    savedLists: [],
    importedSavedLists: []
  }
